import axiosMethods from '@/api/apiManager';
import * as APPDATA from '@/constants/pcConstAppData';

export async function GetCycleParam() {
  try {
    // fetch data from a url endpoint
    const response = await axiosMethods.get(APPDATA.API.CYCLE_PARAM);
    const {data} = response;
    return data;
  } catch (error) {
    // alert(error); // catches both errors
    console.error(error);
    throw error;
  }
}

export function GetCycleParam2() {
  return axiosMethods.get(APPDATA.API.CYCLE_PARAM).then((response) => response.data);
}
